
/* injects from baggage-loader */

'use strict';

import uiModule from './components/ui';
import dialogModule from './components/dialogs/dialogs.module';

export default angular.module('index.components', [
	dialogModule.name,
	uiModule.name
]);



// WEBPACK FOOTER //
// ./src/app/index.components.js